import React, { Component } from "react";
import { FaCircleDot } from "react-icons/fa6";
import axios from "axios";
import DateDisplay from "./dateformate";
import moment from 'moment';
import { Helmet } from "react-helmet-async";

// import GoogleCalendarButton from "./googlesavedate";



class DescribeBody extends Component {
    state = {
        course: [],
        
    };

    //   this is for getting the api content 
    componentDidMount() {
        this.setState({course: this.props.course})
    }
    componentDidUpdate(prevProps) {
        if (this.props.course !== prevProps.course) {
            this.setState({course: this.props.course})
            // this.fetchCourses();
        }
    }



    // fetchCourses = async () => {
    //     const accessToken = localStorage.getItem("accessToken");

    //     try {
    //         const course_id = this.props.course_id
    //         const courseId = parseInt(course_id, 10);
    //         let headers = {}; // Initialize an empty headers object

    //         if (accessToken) {
    //             headers = {
    //                 Authorization: `Bearer ${accessToken}`,
    //             };
    //         }

    //         const response = await axios.get("https://api.geoinfoacademy.com/api/courses/" + courseId, {

    //             headers: headers,

    //         });
    //         this.setState({ course: response.data});
    //         console.log("API Response:", response.data);
    //         this.findAndSetDisplayData()
    //         this.props.onDone();
    //     } catch (error) {
            
    //           if (error.response) {
    //             // Server responded with a status code
    //             if (error.response.status === 401) {
    //               console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
    //               localStorage.removeItem("accessToken");
    //               localStorage.removeItem("user");
    //               window.location.href = "/";
    //             } else {
    //               console.error("Error response from API:", error.response);
    //               this.setState({ loading: false });
    //             }
    //           } else if (error.code === "ERR_NETWORK") {
    //             console.error("Network error detected. Possibly no internet or server is down.");
    //             this.setState({ loading: false  })
    //             this.props.networkIssue()
    //           } else {
    //             // Any other unexpected error
    //             console.error("Unexpected error:", error);
    //             this.setState({ loading: false });
    //           }
    //     }
    // };

    fetchCourses = () =>{
        this.props.fetchcourse()
    }





    handlePayForCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const { course } = this.state;

        if (!course || !course.id || !course.price) {
            console.error("Course data is incomplete.");
            return;
        }

        try {
            const response = await axios.post(
                `https://api.geoinfoacademy.com/api/pay/${course.id}/`,
                {
                    amount_paid: course.price,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data && response.data.payment_url) {
                window.location.href = response.data.payment_url;
            } else {
                console.error("Payment URL not found in response.");
            }
        } catch (error) {
            console.error("Error initiating payment:", error);
        }
    };


    handleRedirect = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            // Navigate if already logged in
            try {
                const response = await axios.get("https://api.geoinfoacademy.com/api/student/profile/", {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                const profileData = response.data;

                if (
                    profileData.first_name === "" ||
                    profileData.last_name === "" ||
                    profileData.middle_name === "" ||
                    profileData.phone_number === "" ||
                    profileData.address === "" ||
                    profileData.email === "" ||
                    profileData.country === "" ||
                    profileData.city === "" ||
                    profileData.venue === "" ||
                    profileData.interested_course === "" ||
                    profileData.source === ""
                ) {
                    const formdisplay = document.querySelector("div.dash_add_course_cover.applyform")
                    formdisplay.style.display = "flex"

                } else {

                    try {
                        const response = await axios.post(
                            `https://api.geoinfoacademy.com/api/interested-courses/`,
                            {
                                course_id: course_id, // Place course_id in the request body
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accessToken}`,
                                },
                            }
                        );
                        console.log(response.data.message)
                        window.location.href = `/description/${course_id}/paymentverify`;
                    }
                    catch (error) {
                        console.error("Error initiating payment:", error);
                    }
                }
            }
            catch (error) {
                console.error("Error fetching data:", error);
                // Handle errors as needed
            }
        } else {
            localStorage.setItem('redirectCourseId', course_id );
            localStorage.setItem('redirectCourseTitle', this.state.course.title ); // Store course ID
            localStorage.setItem('redirectCourseaction', "apply");
            window.location.href = '/login'; // Redirect to login
        }

    };

    handleSavedCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            try {
                const response = await axios.post(
                    `https://api.geoinfoacademy.com/api/saved-courses/`,
                    {
                        course_id: course_id, // Place course_id in the request body
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                console.log(response.data.message)
                this.fetchCourses()
                // Navigate if already logged in

            }
            catch (error) {
                console.error("Error initiating payment:", error);
            }
        } else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            localStorage.setItem('redirectCourseTitle', this.state.course.title); // Store course ID
            localStorage.setItem('redirectCourseaction', "save");
            window.location.href = '/login'; // Redirect to login
        }
    };


    handleUnSavedCourse = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        if (accessToken) {
            try {
                const response = await axios.post(
                    `https://api.geoinfoacademy.com/api/unsave/`,
                    {
                        course_id: course_id, // Place course_id in the request body
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );
                console.log(response.data.message)
                this.fetchCourses()
                // Navigate if already logged in

            }
            catch (error) {
                console.error("Error initiating payment:", error);
            }
        } else {
            localStorage.setItem('redirectCourseId', course_id); // Store course ID
            window.location.href = '/login'; // Redirect to login
        }
    };


    changeltimeformate = (durationFromString, durationToString) => {
        const getMonthName = (month) => {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            return monthNames[month];
        };

        // Create Date objects from the date strings
        const dateObjectfrom = new Date(durationFromString);
        const dateObjectto = new Date(durationToString);

        const monthWordfrom = getMonthName(dateObjectfrom.getMonth());
        const monthWordto = getMonthName(dateObjectto.getMonth());
        const day = dateObjectfrom.getDate();
        // const year = dateObjectfrom.getFullYear();
        const dayto = dateObjectto.getDate();
        const yearto = dateObjectto.getFullYear();

        // Construct the formatted string without the time
        const formattedDateRange = `From ${monthWordfrom} ${day} - ${monthWordto} ${dayto} (10am) ${yearto}`;

        return formattedDateRange;
    }









    findAndSetDisplayData = () => {
        // Access the data array from props
        const { data } = this.state.course.duration;

        // Handle case where data prop might not be provided or is empty
        if (!data || data.length === 0) {
            this.setState({ currentDisplay: null, DateFormate: '' });
            return;
        }

        const now = new Date();
        const currentYear = now.getFullYear();

        let activeData = null;
        let nextUpcomingData = null;

        // First, check for active data based on actual year
        for (const item of data) {
            const actualFrom = new Date(item.duration_from);
            const actualTo = new Date(item.duration_to);
            const actualNow = now;

            if (actualNow >= actualFrom && actualNow <= actualTo) {
                activeData = item;
                break;
            }
        }

        // If no active data found, then find the next upcoming considering actual year
        if (!activeData) {
            let minFutureDate = Infinity;
            let futureItem = null;

            for (const item of data) {
                const actualFrom = new Date(item.duration_from);
                if (actualFrom > now && actualFrom.getTime() < minFutureDate) {
                    minFutureDate = actualFrom.getTime();
                    futureItem = item;
                }
            }
            nextUpcomingData = futureItem;
        }

        // If no active data and no future data in the current year,
        // loop back to the earliest period in the *next* year
        if (!activeData && !nextUpcomingData) {
            let earliestData = null;
            if (data.length > 0) {
                earliestData = data.reduce((prev, curr) => {
                    const prevFrom = new Date(prev.duration_from);
                    const currFrom = new Date(curr.duration_from);
                    if (prevFrom.getMonth() < currFrom.getMonth()) {
                        return prev;
                    } else if (prevFrom.getMonth() === currFrom.getMonth()) {
                        return prevFrom.getDate() < currFrom.getDate() ? prev : curr;
                    } else {
                        return curr;
                    }
                });

                const nextYearFrom = new Date(earliestData.duration_from);
                nextYearFrom.setFullYear(currentYear + 1);
                const nextYearTo = new Date(earliestData.duration_to);
                nextYearTo.setFullYear(currentYear + 1);

                nextUpcomingData = {
                    ...earliestData,
                    duration_from: nextYearFrom.toISOString().split('T')[0],
                    duration_to: nextYearTo.toISOString().split('T')[0],
                };
            }
        }

        this.setState({
            currentDisplay: activeData || nextUpcomingData,
        });
    };




    handleAddToCalendar = async (accessToken) => {
        // You'll need to fetch/determine the actual course start/end times and title
        // from your course data.
        const { currentDisplay } = this.state;
        if (!currentDisplay) return;

        // const dateObjectFrom = new Date(currentDisplay.duration_from);
        // const dateObjectTo = new Date(currentDisplay.duration_to);

        // const dayFrom = this.getDayWithOrdinal(dateObjectFrom.getDate());
        // const monthAbbrFrom = this.getAbbreviatedMonthName(dateObjectFrom.getMonth());
        // const yearFrom = dateObjectFrom.getFullYear();

        // const dayTo = this.getDayWithOrdinal(dateObjectTo.getDate());
        // const monthAbbrTo = this.getAbbreviatedMonthName(dateObjectTo.getMonth());
        // const yearTo = dateObjectTo.getFullYear();

        // let formattedDateTime = '';

        // if (monthAbbrFrom === monthAbbrTo && yearFrom === yearTo) {
        //   formattedDateTime = `${dayFrom} - ${dayTo} ${monthAbbrTo} | ${yearTo}`;
        // } else if (yearFrom === yearTo) {
        //   formattedDateTime = `${dayFrom} ${monthAbbrFrom} - ${dayTo} ${monthAbbrTo} | ${yearTo}`;
        // } else {
        //   formattedDateTime = `${dayFrom} ${monthAbbrFrom} ${yearFrom} - ${dayTo} ${monthAbbrTo} ${yearTo}`;
        // }
        const courseTitle = this.state.course.title
        const courseLocation = "Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos"
        const courseStartDate = currentDisplay.duration_from
        const courseEndDate = currentDisplay.duration_to
        // const { courseTitle, courseStartDate, courseEndDate, courseLocation } = this.state; // Or from props

        if (!courseTitle || !courseStartDate || !courseEndDate) {
            this.setState({ error: "Course details missing for calendar event." });
            setTimeout(() => this.setState({ error: '' }), 5000);
            return;
        }

        // Format dates for Google Calendar API (ISO 8601)
        const startDateTime = moment(courseStartDate).toISOString();
        const endDateTime = moment(courseEndDate).toISOString();

        const event = {
            summary: `Enrolled in Course: ${courseTitle}`,
            location: courseLocation || this.state.venue, // Use course location or training venue
            description: `You have successfully enrolled in ${courseTitle}. For more details, visit your dashboard.`,
            start: {
                dateTime: startDateTime,
                timeZone: 'Africa/Lagos', // Adjust to your default timezone
            },
            end: {
                dateTime: endDateTime,
                timeZone: 'Africa/Lagos', // Adjust to your default timezone
            },
            reminders: {
                useDefault: false,
                overrides: [
                    { method: 'email', minutes: 24 * 60 }, // 1 day before
                    { method: 'popup', minutes: 15 },    // 15 minutes before
                ],
            },
        };

        try {
            const response = await axios.post(
                'https://www.googleapis.com/calendar/v3/calendars/primary/events',
                event,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );
            console.log('Event created on Google Calendar:', response.data);
            this.setState({ error: 'Course added to Google Calendar successfully!' });
        } catch (error) {
            console.error('Error adding event to Google Calendar:', error.response ? error.response.data : error.message);
            this.setState({ error: `Failed to add to calendar: ${error.response ? (error.response.data.error.message || 'Unknown error') : 'Network error'}` });
        } finally {
            setTimeout(() => this.setState({ error: '' }), 5000);
        }
    };



    render() {
        const course = this.state.course
        // console.log("input", course)
        console.log("Helmet course:", course.title);

        return (
            <>
            <Helmet key={course.id || "default"}>
                <title>{course.title ? `${course.title} | GeoInfo Academy` : "Course Details"}</title>
                <meta 
                    name="description" 
                    content={
                        course.description ||
                        course.tags ||
                        course.title ||
                        "GeoInfo Academy Professional Course"
                    } 
                />

                <meta property="og:title" content={course.title} />
                <meta property="og:description" content={course.short_description || course.title} />
                <meta property="og:image" content={course.thumbnail} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`https://geoinfoacademy.com/description/${course.id}/${course.description}`} />
            </Helmet>
            <div className="dash_description_body" >
                <img src={course.thumbnail} alt={"course image" + course.id} className="descrip_image" />
                <div className="content">
                    <div className="title">
                        <h2>{course.title}</h2>
                    </div>
                    <p>
                        <span>{course.tags} </span> <FaCircleDot />
                        <span>{course.training_type}</span> <FaCircleDot />
                        {/* {this.state.course.repeat && this.state.course.interval ? ( 
                            <span>{course.repeat} </span>*/}
                        {/* <span>{course.interval} </span></span>) : ((course.duration_from && course.duration_to) ? (<span><span>{this.changeltimeformate(course.duration_from, course.duration_to)}</span></span>) : null)
                        } 
                        <FaCircleDot />*/}
                        <span><DateDisplay data={course.duration} /> </span>
                        {/* <GoogleCalendarButton onAddToCalendar={(accessToken) => this.handleAddToCalendar(accessToken)} /> */}
                    </p>

                    <button className="direct first" onClick={this.handleRedirect}>Apply For Course</button>
                    {course.saved ? <button className="direct" onClick={this.handleUnSavedCourse}>Remove From Library</button> :
                        <button className="direct" onClick={this.handleSavedCourse}>Save To Library</button>}
                </div>

            </div>
            
            </>
        ) 
    }
}

export default DescribeBody